import { useStore } from '@nanostores/react';
import { Button } from '~/components/ui/Button';
import { useCurrentMessage } from '~/lib/context/message';
import { versionHistoryStore } from '~/lib/stores/version-history/version-history';

export function ArtifactSnapshotActions() {
  const message = useCurrentMessage();
  const snapshots = useStore(versionHistoryStore.snapshots);
  const snapshot = message ? snapshots.find((item) => item.messageId === message.id) : undefined;
  const previewedVersion = useStore(versionHistoryStore.previewedSnapshot);
  const isPreviewed = previewedVersion && snapshot ? previewedVersion.messageId === snapshot.messageId : false;
  const isLatestSnapshot = snapshot && snapshot.messageId === snapshots.at(0)?.messageId;

  if (!snapshot || isLatestSnapshot) {
    return null;
  }

  return (
    <div className="absolute bottom-0 right-4 shadow translate-y-1/2 flex border border-bolt-elements-borderColor rounded-lg bg-bolt-elements-background-depth-3 p-px">
      <Button
        startIcon="i-bolt:clock-rewind"
        size="sm"
        variant="ghost"
        onClick={() => versionHistoryStore.restoreConfirmationDialog.open(snapshot)}
      >
        Restore
      </Button>

      <Button
        startIcon={isPreviewed ? 'i-heroicons:eye-slash' : 'i-heroicons:eye'}
        size="sm"
        variant="ghost"
        onClick={() => versionHistoryStore.previewSnapshot(snapshot)}
      >
        {isPreviewed ? 'Exit preview' : 'Preview'}
      </Button>
    </div>
  );
}
